import axios from "axios";
import {
  GET_ALL_TRIAL_BALANCE,
} from "../../../config/config";
import { IAPIPayload } from "../../../interfaces/apiInterface";

export const getAllTrialBalanceList = (data: IAPIPayload) => {
  return axios.post(GET_ALL_TRIAL_BALANCE, data);
};
